import { IProps } from '@/Interfaces/Icons/Props.interface';

const BrowserIcon = (props: IProps) => {
  return (
    <svg width='24' height='24' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg' {...props}>
      <path
        d='M22.25 9.75H1.75V19.5C1.75 21.0188 2.98122 22.25 4.5 22.25H19.5C21.0188 22.25 22.25 21.0188 22.25 19.5V9.75Z'
        fill='currentColor'
      />
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M1.75 4.5C1.75 2.98122 2.98122 1.75 4.5 1.75H19.5C21.0188 1.75 22.25 2.98122 22.25 4.5V8.25002H1.75V4.5ZM14 4C13.4477 4 13 4.44772 13 5C13 5.55228 13.4477 6 14 6H14.009C14.5612 6 15.009 5.55228 15.009 5C15.009 4.44772 14.5612 4 14.009 4H14ZM17.991 4C17.4388 4 16.991 4.44772 16.991 5C16.991 5.55228 17.4388 6 17.991 6H18C18.5523 6 19 5.55228 19 5C19 4.44772 18.5523 4 18 4H17.991Z'
        fill='currentColor'
      />
    </svg>
  );
};

export default BrowserIcon;
